import Happening from './Happening';

export default Happening;